import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getContent } from '../../services/api';
import LineHeader from './LineHeader';
import QuickLinksSection from '../../components/QuickLinksSection';
import Accordion from './Accordion';

const MainCover = styled.section`
  max-width: 1060px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 80px auto 150px;
`;

class SalonListGrooming extends Component {
  static defaultProps = {
    prefectures: [],
  };

  static propTypes = {
    locale: PropTypes.string.isRequired,
    prefectures: PropTypes.arrayOf(PropTypes.shape()),
  };

  constructor(props) {
    super(props);
    this.state = {
      salonList: null,
    };
  }

  componentDidMount() {
    const { locale } = this.props;
    getContent({ contentType: 'salonListUnique', locale }).then(res => {
      if (res !== undefined) {
        this.setState({ salonList: res.salonList });
      }
    });
  }

  // addSalonData = prefectures => {
  //   console.log(prefectures);
  // };

  convertRegionData = prefectures => prefectures.map((region, i) => ({ id: `regions-${i}`, label: region.region }));

  render() {
    const { prefectures } = this.props;
    const regions = this.convertRegionData(prefectures);
    return (
      <React.Fragment>
        <LineHeader />
        <QuickLinksSection links={regions} />
        <MainCover>
          <Accordion regions={prefectures} salonList={this.state.salonList} />
        </MainCover>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  // data: getPageData(state, { ...props, dataLevel: 2 }),
  siteOption: state.siteOptions,
  copy: state.siteOptions.siteCopySalonLocator,
  prefectures: state.siteOptions.prefectures,
  locale: state.locale,
  lines: state.siteOptions.menu,
});

export default connect(mapState)(SalonListGrooming);



// WEBPACK FOOTER //
// ./src/pages/SalonListGrooming/index.js